import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Card, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Otif from '../../../../components/Dashboard/PerformanceCardInfoTooltips/Otif';
import OnTimeCollection from '../../../../components/Dashboard/PerformanceCardInfoTooltips/OnTimeCollection';
import CancellationAndReturn from '../../../../components/Dashboard/PerformanceCardInfoTooltips/CancellationAndReturn';
import OnTimeDelivery from '../../../../components/Dashboard/PerformanceCardInfoTooltips/OnTimeDelivery';
import NonReturnedAndOnTimeCompleteCollection
  from '../../../../components/Dashboard/PerformanceCardInfoTooltips/NonReturnedAndOnTimeCompleteCollection';
import NonReturnedCompleteCollection
  from '../../../../components/Dashboard/PerformanceCardInfoTooltips/NonReturnedCompleteCollection';
const { Title } = Typography;

const PerformanceKeyComponents = {
  'NON_RETURNED_AND_ON_TIME_COMPLETE_COLLECTION': NonReturnedAndOnTimeCompleteCollection,
  'NON_RETURNED_COMPLETE_COLLECTION': NonReturnedCompleteCollection,
  'ON_TIME_COLLECTION': OnTimeCollection,
  'ON_TIME_DELIVERY': OnTimeDelivery,
  'OTIF': Otif,
  'CANCELLATION_AND_RETURN': CancellationAndReturn,
};
const PerformanceDashboard = () => {
  const [performanceCardKey, setPerformanceCardKey] = useState(null);
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (location?.state?.performanceCardKey.key) {
      setPerformanceCardKey(location.state.performanceCardKey);
    }
  }, []);

  const SelectedComponent = PerformanceKeyComponents[performanceCardKey?.key];

  return (
    <>
      {SelectedComponent &&
        <Card style={{width:'100%',height: '70vh'}} title={<Title level={3}>{performanceCardKey?.title}</Title>}>
          <SelectedComponent />
        </Card>
      }
    </>
  );
};

export default PerformanceDashboard;
